###*
  * Allows user to manage settings and filters on the page
###

class INTENT.report.SettingsManager

  constructor: (@controller) ->
    @code = @controller.code + '-settings'
    @attr = @controller.attr + '-settings'
    @el = @controller.el
    @datasets = @controller.datasets
    @enums = {}
    @defaults =
      grouping: ['day']
      period: 'this_month'

    @changed_fields = {}
    @watch_hash = true
    @search_delay = 200
    @filters_container = $ "[#{@attr}-filters]"
    @select2_helper = new INTENT.report.Select2Helper @

    @init_events()
    @init_grouping_fields()

    @periodManager = new INTENT.report.SettingsPeriodManager @
    @parser = new INTENT.report.SettingsParser @
    @renderer = new INTENT.report.Renderer @controller

    settings = @parser.parse_hash()
    if settings.dataset_name
      @parser.render_form settings
    else
      dataset = @controller.get_dataset()
      @add_filter()
      @set_grouping @defaults.grouping
      @set_period dataset.defaults.period || @defaults.period

    @clear_changed_fields()
    @toggle_time_inputs()
    @toggle_timezone_input()

  get_settings: () =>
    @parser.parse_form()

  remember_settings: (settings) =>
    @parser.render_hash settings

  set_dataset: (dataset_code) =>
    @controller.set_dataset_code dataset_code

  set_grouping: (groups) =>
    if _.isArray groups
      $("[#{@attr}-grouping]").val(groups).trigger('change')

  get_grouping: () =>
    $("[#{@attr}-grouping]").val()

  set_period: (period) =>
    @periodManager.set_period period

  set_dates: (start, end) =>
    @periodManager.set_start_date start
    @periodManager.set_end_date end

  get_dates: () =>
    return {
      start: @periodManager.get_start_date()
      end: @periodManager.get_end_date()
    }

  set_timezone: (timezone) =>
    dataset = @controller.get_dataset()

    if dataset.disable_timezone_select
      timezone = dataset.default_timezone

    if timezone?
      $("[#{@attr}-timezone]").val(timezone).trigger('change')

  get_timezone: () =>
    $("[#{@attr}-timezone]").val()

  set_order: (key, direction) =>
    $("[#{@attr}-order]").val "#{key}/#{direction}"

  set_changed_field: (field) =>
    @changed_fields[field] = true

  unset_changed_field: (field) =>
    @changed_fields[field] = false

  get_changed_field: (field) =>
    !!@changed_fields[field]

  clear_changed_fields: () =>
    @changed_fields = {}

  ###*
   * @return {object|undefined}
  ###
  get_order: () =>
    val = $("[#{@attr}-order]").val().split('/')
    if val[0]? and val[1]?
      order =
        key: val[0]
        direction: val[1]

    return order

  add_filter: (type = 'key', key, condition, initial_values) =>
    group_id = @filters_container.find("[#{@attr}-group]").last().data("#{@code}-group") + 1 || 0
    group = $ @get_filter_html(group_id, type)
    @filters_container.append $(group)

    fields_list = @controller.get_fields_list null, type

    @init_key_select group, fields_list, key, type
    @init_condition_select group, condition
    if type is 'key'
      @init_values_select group, key, initial_values
    else
      @init_values_input group, key, initial_values

  append_filter: (key, condition, value) =>
    if !key? or !condition? or !value?
      return @add_filter 'key', key, condition, value

    last_found_group = null
    @filters_container.find("[#{@attr}-group]").each (i, group) =>
      group = $ group
      item_key = group.find("[#{@attr}-item-key]").val()
      item_condition = group.find("[#{@attr}-item-condition]").val()
      if item_key is key and item_condition is condition
        last_found_group = group

    if !last_found_group?
      return @add_filter 'key', key, condition, if _.isObject(value) then value.id else value
    else
      select = last_found_group.find("[#{@attr}-item-values]")
      select.select2AppendValues value


  get_filters: () =>
    filters = []
    $("[#{@attr}-group]").each (index, group) =>
      group = $ group
      type = group.attr("#{@attr}-group-type")
      key = group.find("[#{@attr}-item-key]").val()
      condition = group.find("[#{@attr}-item-condition]").val()
      values = group.find("[#{@attr}-item-values]").val()
      values = null if values == ''

      if key? and condition? and values?
        filters.push
          key: key
          condition: condition
          type: type
          values: decodeURIComponent(values)
    return filters

  get_group: (group) =>
    if _.isNumber group
      group = $ "[#{@attr}-group='#{group}']"
    return group

  set_defaults: (dataset_code) =>
    if !@get_changed_field('period')
      dataset = @controller.get_dataset(dataset_code)
      @periodManager.set_period dataset.defaults.period || @defaults.period

  init_grouping_fields: (dataset_code) =>
    select = $ "[#{@attr}-grouping]"
    values = _.intersection select.val(), @controller.get_fields(dataset_code)
    grouping_fields = @controller.get_fields_list(dataset_code)

    @toggle_time_inputs()
    @toggle_timezone_input()

    select.destroySelect2 clear:true
    select.select2({
      data: grouping_fields
    })
    select.val(values).trigger('change')

  init_key_select: (group, key_fields_list, initial_values, type = 'key') =>
    group = @get_group group

    key_fields_list.unshift {
      id: '',
      text: ''
    }
    element = group.find("[#{@attr}-item-key]")
    element.destroySelect2({clear:true}).select2({
      data: key_fields_list,
      placeholder: __("report.filter.item.#{type}.placeholder")
    })
    if initial_values?
      element.val(initial_values).trigger('change')

  update_key_selects: (dataset_code) =>
    @remove_unavailable_filters(dataset_code)
    value_fields_list = @controller.get_fields_list dataset_code, 'value'
    $("[#{@attr}-item-key]").each (index, item) =>
      item = $ item
      group = item.closest "[#{@attr}-group]"
      type = group.attr "#{@attr}-group-type"
      if type is 'value'
        @init_key_select group, value_fields_list, item.val(), 'value'

  init_condition_select: (group, initial_values) =>
    group = @get_group group
    element = group.find("[#{@attr}-item-condition]")
    element.destroySelect2({clear:true}).select2({
      minimumResultsForSearch: Infinity,
      width: 'resolve'
    })
    if initial_values?
      element.val(initial_values).trigger('change')

  init_values_select: (group, field_code, initial_values) =>
    if initial_values? and !_.isArray(initial_values)
      initial_values = [initial_values]

    group = @get_group group

    select = group.find("select[#{@attr}-item-values]")
    unless field_code
      select.select2()
      return

    dataset = @controller.get_dataset()
    relation = dataset.relations[field_code]

    if _.isObject(relation)
      if relation.type in ['enum']
        @select2_helper.init_select2_enum select, field_code, initial_values
      else if relation.type in ['object', 'geo', 'user', 'database']
        @select2_helper.init_select2_object select, field_code, initial_values
      else if relation.type in ['boolean']
        @select2_helper.init_select2_boolean select, initial_values
    else
      @select2_helper.init_select2_plain(select, initial_values)

  init_values_input: (group, field_code, initial_values) =>
    input = group.find("input[#{@attr}-item-values]")
    if initial_values?
      input.attr 'disabled', false
      input.val initial_values

  remove_filter: (group) =>
    group = $ group
    group.find('select.select2-init').destroySelect2()
    group.remove()

  remove_filters: () =>
    $("[#{@attr}-group]").each (index, group) =>
      @remove_filter group

  reset_settings: () =>
    $("[#{@attr}-grouping]").val([]).trigger('change')

  remove_unavailable_filters: (new_dataset_code) =>
    key_fields = @controller.get_fields new_dataset_code, 'key'
    value_fields = @controller.get_fields new_dataset_code, 'value'
    key_fields_list = @controller.get_fields_list new_dataset_code, 'key'
    value_fields_list = @controller.get_fields_list new_dataset_code, 'value'

    $("[#{@attr}-item-key]").each (index, item) =>
      item = $ item
      item_code = item.val()
      group = item.closest "[#{@attr}-group]"
      if not item_code
        type = group.attr "#{@attr}-group-type"
        if type is 'key'
          @init_key_select group, key_fields_list
        else
          @init_key_select group, value_fields_list, null, 'value'
      else if item_code in value_fields
        @init_key_select group, value_fields_list, null, 'value';
        item.val(item_code).trigger('change')
      else if item_code in key_fields
        @init_key_select group, key_fields_list
        item.val(item_code).trigger('change')
      else
        @remove_filter group

  set_watch_hash: (is_enabled) =>
    @watch_hash = is_enabled

  get_filter_html: (index = 0, type = 'key') =>
    if type is 'key'
      options = [{name: "=", value: "eq"}, {name: "&ne;", value: "ne"}, {name: "<", value: "lt"}, {name: "&le;", value: "le"}, {name: ">", value: "gt"}, {name: "&ge;", value: "ge"}]
      input = "<select #{@attr}-item-values disabled=\"disabled\" multiple=\"multiple\" data-tags=\"true\" data-token-separators=\"[';','\n','\t']\"></select>"
    else
      options = [{name: "<", value: "lt"}, {name: "&le;", value: "le"}, {name: ">", value: "gt"}, {name: "&ge;", value: "ge"}]
      input = "<input #{@attr}-item-values type=\"text\" disabled=\"disabled\" class=\"form-control\" value=\"\"/>"

    options = options.map (item) =>
      return "<option value=\"#{item.value}\">#{item.name}</option>"

    return """
    <tr class="filter-box" #{@attr}-group='#{index}' #{@attr}-group-type='#{type}'>
        <td class="col-md-4">
            <select #{@attr}-item-key
                    class=""
            ></select>
        </td>
        <td class="col-md-1">
            <div style="width:65px">
              <select #{@attr}-item-condition
                      class=""
              >
                  #{options}
              </select>
            </div>
        </td>
        <td class="col-md-7">
            #{input}
        </td>
        <td class="filter-remove">
            <span #{@attr}-filters-remove class="remove-filter">
                <i class="fa fa-times opacity-dynamic"></i>
            </span>
        </td>
    </tr>
    """

  toggle_time_inputs: () =>
    dataset = @controller.get_dataset()
    if dataset.time_enabled is false
      $("#period, #timezone").attr "disabled", true
      $(".time_row").hide();
    else
      $("#period, #timezone").attr "disabled", false
      $(".time_row").show();

  toggle_timezone_input: () =>
    dataset = @controller.get_dataset()
    if dataset.disable_timezone_select or dataset.time_enabled is false
      $("#timezone").attr "disabled", true
      $("#timezone").parents('.time_row').hide()
    else
      $("#timezone").attr "disabled", false
      $("#timezone").parents('.time_row').show()

  init_events: () =>
    $(document).on "change", "#timezone", (e) =>
      start_date = @periodManager.get_start_date()
      end_date = @periodManager.get_end_date()
      @periodManager = new INTENT.report.SettingsPeriodManager @
      @periodManager.set_start_date(start_date)
      @periodManager.set_end_date(end_date)

    $(document).on "#{@controller.code}:dataset_changed", (e, dataset_code) =>
      @remove_unavailable_filters dataset_code
      @init_grouping_fields dataset_code

    $("[#{@attr}-period]").on 'change apply.daterangepicker', (e) =>
      if (e.type is 'apply') or (e.originalEvent and e.originalEvent.isTrusted)
        @set_changed_field 'period'

    $(window).on 'hashchange', (e) =>
      if !@watch_hash
        return
      @remove_filters()
      @reset_settings()

      settings = @parser.parse_hash()
      if settings.dataset_name
        @parser.render_form settings
      else
        @add_filter()

    $(document).on "click", "[#{@attr}-filters-add]", (e) =>
      target = $ e.target
      e.preventDefault()
      target.blur()
      @add_filter target.attr 'filter-type'

    $(document).on "click", "[#{@attr}-filters-remove]", (e) =>
      e.preventDefault()
      self = $ e.currentTarget
      group = self.closest("[#{@attr}-group]")
      @remove_filter(group) if group.length

    $(document).on 'click', '.filter-by', (e) =>
      e.preventDefault()
      self = $ e.currentTarget
      td = self.closest('td')
      filter_text = td.text().trim()
      filter_value = td.find('[data-value]').data('value') || filter_text
      if typeof filter_value is 'string'
        filter_value = filter_value.trim()

      th = td.closest('table').find('th').eq(td.index())
      filter_key = th.data('key')
      if typeof filter_key is 'string'
        filter_key = filter_key.trim()

      if filter_key is 'segment_id'
        filter_key = 'user_segments'

      @append_filter filter_key, 'eq', {id: filter_value, text: filter_text}

    $(document).on 'click', 'th.sortable', (e) =>
      e.preventDefault()
      self = $ e.currentTarget
      key = self.attr('data-key')
      if key?
        order = @get_order()
        if order? and key is order.key
          direction = if order.direction is 'desc' then 'asc' else 'desc'
        else
          direction = if order? and order.direction in ['asc', 'desc'] then order.direction else 'desc'

        @set_order key, direction

        tableData = @controller.tableData

        if tableData == null or !tableData.data.allowClientSort
          @controller.show_report()
        else
          @controller.sort_report(key, direction)

    $(document).on "select2:selecting", "[#{@attr}-item-key]", (e) =>
      self = $ e.currentTarget
      old_key = self.val()
      new_key = e.params.args.data.id

      if new_key and old_key != new_key
        group = self.closest("[#{@attr}-group]")
        group.find("input[#{@attr}-item-values]").attr('disabled', false)
        if group.length
          @init_values_select(group, new_key)
